import Vue from 'vue';
import bus from '../../plugins/bus';

export default Vue.extend({
  data() {
    return {
      isVisible: false,
      classModifier: '',
    };
  },

  methods: {
    hide() {
      this.isVisible = false;
      this.onHide();
    },

    onHide() {

    },

    show() {
      this.onShow();
      this.isVisible = true;
    },

    onShow() {

    },

    onReceiveOpen(name) {
      if (this.$options.name === name) {
        this.show();
      }
    },
  },

  mounted() {
    bus.$on('openModal', this.onReceiveOpen);
  },
});



// WEBPACK FOOTER //
// ./src/js/components/modals/index.js